import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import CareerPreferencesMarketPage from '../containers/CareerPreferencesMarketPage.jsx';
import createContainer from '../containers/create-prompt-container.jsx';

const Container = createContainer(CareerPreferencesMarketPage);

const styles = StyleSheet.create({
    container: {
        width: 'auto', // Overrides .mod.flex which causes right-margin to disappear
        minHeight: 410,
    },
});

export default function CareerPreferencesMarketPageView(props) {
    return (
        <Container
            className={`mod ${css(styles.container)}`}
            onComplete={props.onComplete}
            onDismiss={props.onDismiss}
        />
    );
}

CareerPreferencesMarketPageView.propTypes = {
    onDismiss: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./views/CareerPreferencesMarketPageView.jsx